.ko{bottom:0.25rem;}